import * as React from "react";
import Confetti from "react-confetti";
import bg from "../assets/images/rainbow.png";

function Start() {
  // Function to handle sharing on Twitter
  const shareOnTwitter = () => {
    const url = "https://juice-cosmetics.vercel.app"; // Your desired link
    const text = "🎉 I'm a step closer in turning my wildest color wish into reality! Participate in the ‘Wish a Color, We Deliver’ Contest and get a chance to win your own personalized nail polish color! 💄Challenge JUICE COSMETICS now! #WishAColorContest #JuiceCosmetics\n";
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
    window.open(twitterUrl, "_blank");
  };

  // Function to handle sharing on Facebook
  const shareOnFacebook = () => {
    const url = "https://juice-cosmetics.vercel.app"; // Your desired link
    const text = "🌟🎨 Check out this amazing contest! I'm a step closer in turning my wildest color wish into reality! 💅✨ Participate in the ‘Wish a Color, We Deliver’ Contest and get a chance to win your own personalized nail polish color! 💄 Challenge JUICE COSMETICS now! #WishAColorContest #JuiceCosmetics"; // Your custom text
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`;
    window.open(facebookUrl, "_blank");
  };

  // Function to handle sharing on Instagram
  const shareOnInstagram = () => {
    const url = "https://juice-cosmetics.vercel.app"; // Your desired link
    const text = "Check out this amazing contest! #WishAColorContest"; // Your custom text
    // For Instagram, you may need to direct users to your profile and let them post manually.
    // alert(`Share this link: ${url} and paste the text: ${text} in your Instagram post.`);
    const instaUrl = "https://www.instagram.com/p/C6LLOuxs5NG/?img_index=1";
    window.open(instaUrl, "_blank");
  };

  // Function to handle sharing on WhatsApp
  const shareOnWhatsApp = () => {
    const url = "https://juice-cosmetics.vercel.app"; // Your desired link
    const text = "🌟🎨 I'm a step closer in turning my wildest color wish into reality!\n\n💅✨ Participate in the ‘Wish a Color, We Deliver’ Contest and get a chance to win your own personalized nail polish color!\n\n💄 Challenge JUICE COSMETICS now!\n#WishAColorContest #JuiceCosmetics\n\n🎁Participation Link:"; // Your custom text
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}%0A${encodeURIComponent(url)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <Confetti />
      <div className="flex items-center justify-center min-h-screen px-4 text-center">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div class="relative overflow-hidden">
          <div class="inline-block align-bottom bg-white rounded-lg px-2  pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <div class="text-center p-8 pb-8 z-10">
              <h1 class="text-3xl md:text-5xl font-bold bg-gradient-to-br from-[#7a0242] via-[#f32d9a] via-[#f7568b]  to-[#4dfc03] inline-block text-transparent bg-clip-text">
                THANK YOU
              </h1>
              <p class="text-sm md:text-xl text-gray-600">
                for your participation in our
              </p>
              <p class="text-xl md:text-xl font-bold text-[#8237B6] pt-4">
                "Wish A Color, We Deliver" Contest!
              </p>
              <div class="fixed bottom-0 right-0 z-0">
                <img src={bg} alt="" class="sm:w-48 sm:h-48 w-32 h-40" />
              </div>
            </div>
            <section class="flex flex-col md:flex-row">
              <div class="flex-1 mx-6 mb-6 mt-0">
                <p class="text-sm text-gray-600 text-center">
                Spread the word and increase your odds of winning!
                </p>
                <hr class="my-2" />
                <div class="flex flex-wrap justify-center">
                  <button onClick={shareOnWhatsApp} class="bg-[#49C958] mx-2 text-center my-auto rounded-lg flex text-white text-xs text-center self-center px-3 py-2 ">
                    
                    <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"/></svg> 
                  </button>
                  <button onClick={shareOnFacebook} class="bg-[#1877F2] mx-2 text-center my-auto rounded-lg flex text-white text-xs text-center self-center px-3 py-2 ">
                    <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 2h-3a5 5 0 0 0-5 5v3H6v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg> 
                  </button>
                  <button onClick={shareOnInstagram} class="bg-black mx-2 text-center instagram my-auto rounded-lg flex text-white text-xs text-center self-center px-3 py-2 ">
                    <svg className="w-5 h-5 " xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"/></svg>
                  </button>
                  <button onClick={shareOnTwitter} class="bg-black z-[99999] mx-2 text-center my-auto rounded-lg flex text-white text-xs text-center self-center px-3 py-2 ">
                  <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M8 2H1l8.26 11.015L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886zm9 18L5 4h2l12 16z"/></svg>
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Start;
